import React, { Component } from 'react';
import { Route, Prompt } from 'react-router-dom';

import TabStructure from '../../ui/tab';

import SubNav from '../sub-nav';
import Utilities from '../utilities/index';

import EventInformation from '../../../containers/event/event-details/event-information';
import FormInformation from '../../../containers/event/event-details/form-information';
import VendorInformation from '../../../containers/event/vendor-information';
import ErrorPage from '../../errorPage';
import Loading from '../../ui/loading-spinner';

import moment from 'moment';
import { last, sortBy } from 'lodash';
import Headline from '../../ui/headline';
import Modal from '../../ui/modal';

class EventDetails extends Component {
    constructor(props) {
        super(props);
        this.formContent = [
            {
                path: 'event-information',
                title: 'Event Information',
                content: <EventInformation eventId={this.props.eventId} />
            },
            {
                path: 'form-information',
                title: 'Form Information',
                content: <FormInformation />
            },
            {
                path: 'vendor-information',
                title: 'Vendor Information',
                content: <VendorInformation />
            }
        ];
    }

    fetchEventData(id) {
        this.props.fetchEvent(id, this.props.history);
    }

    componentDidMount() {
        this.scrollToTop();

        if (this.props.location.state) {
            this.fetchEventData(this.props.location.state.eventId);
        } else if (!this.props.eventId && !this.props.prInfo) {
            this.props.resetEvent();
            this.props.setFormPristine();
        }
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.successMessage && !this.props.successMessage) {
            this.scrollToTop();
        } else if (!nextProps.tabOneValid && this.props.tabOneValid) {
            this.scrollToTop();
            const that = this;
            setTimeout(function() {
                that.props.clearAllErrors();
            }, 10000);
        } else if (!nextProps.tabTwoValid && this.props.tabTwoValid) {
            this.scrollToTop();
            const that = this;
            setTimeout(function() {
                that.props.clearAllErrors();
            }, 10000);
        } else if (
            nextProps.errorMessage ===
                'An event with the same name already exists' ||
            this.props.errorMessage ===
                'An event with the same name already exists'
        ) {
            this.scrollToTop();
        } else if (nextProps.errorMessage && !this.props.errorMessage) {
            this.scrollToTop();
            const that = this;
            setTimeout(function() {
                that.props.clearAllErrors();
            }, 10000);
        } else if (
            nextProps.status === 'Rejected' &&
            this.props.status !== 'Rejected'
        ) {
            this.scrollToTop();
        }
    }

    render() {
        const activeIndex = this.formContent.findIndex(
            item => item.path === this.props.match.params.tab
        );

        let eventRejection = null;
        if (this.props.tasks && this.props.tasks.length > 0) {
            if (
                this.props.status === 'Unapproved' ||
                this.props.status === 'Pending'
            ) {
                const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
                if (mostRecentTask.action === 'Info') {
                    eventRejection = (
                        <div className="event__rejection">
                            <p>
                                More information was requested for this event by{' '}
                                <strong>
                                    {mostRecentTask.updatedByUsername}
                                </strong>{' '}
                                on{' '}
                                <strong>
                                    {moment(mostRecentTask.updatedAt).format(
                                        'MMMM Do, YYYY'
                                    )}
                                </strong>
                            </p>
                            <div>
                                <p>{this.props.rejectComments}</p>
                            </div>
                        </div>
                    );
                }
            }

            if (this.props.status === 'Rejected') {
                const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
                eventRejection = (
                    <div className="event__rejection">
                        <p>
                            This event was rejected by{' '}
                            <strong>{mostRecentTask.updatedByUsername}</strong>{' '}
                            on{' '}
                            <strong>
                                {moment(mostRecentTask.updatedAt).format(
                                    'MMMM Do, YYYY'
                                )}
                            </strong>
                        </p>
                        <div>
                            <p>{this.props.rejectComments}</p>
                        </div>
                    </div>
                );
            }
        }

        let afterActionRequest = null;
        if (this.props.aaTasks && this.props.aaTasks.length > 0) {
            const mostRecentTask = last(sortBy(this.props.aaTasks, 'id'));
            if (mostRecentTask.action === 'Info') {
                afterActionRequest = (
                    <div className="event__rejection">
                        <p>
                            More information was requested for this after action
                            by{' '}
                            <strong>{mostRecentTask.updatedByUsername}</strong>{' '}
                            on{' '}
                            <strong>
                                {moment(mostRecentTask.updatedAt).format(
                                    'MMMM Do, YYYY'
                                )}
                            </strong>
                        </p>
                        <div>
                            <p>{this.props.aaRequestMessage}</p>
                        </div>
                    </div>
                );
            }
        }

        let successMessage = null;
        if (this.props.successMessage) {
            successMessage = (
                <div className="event__success">
                    <span onClick={this.props.clearMessage}>
                        <span className="visually-hidden">
                            Remove the success message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    <p>{this.props.successMessage}</p>
                </div>
            );
        }

        let errorMessage = null;
        if (this.props.errorMessage) {
            errorMessage = (
                <div className="event__error">
                    <span onClick={this.props.clearAllErrors}>
                        <span className="visually-hidden">
                            Remove the error message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    <p>{this.props.errorMessage}</p>
                </div>
            );
        }

        let errorOneMsg = null;
        if (!this.props.tabOneValid) {
            errorOneMsg = (
                <p>
                    Please complete all required fields in the Event Information
                    tab.
                </p>
            );
        }

        let errorTwoMsg = null;
        if (!this.props.tabTwoValid) {
            errorTwoMsg = (
                <p>
                    Please complete all required fields in the Form Information
                    tab.
                </p>
            );
        }

        let errorTabsMessage = null;
        if (errorOneMsg || errorTwoMsg) {
            errorTabsMessage = (
                <div className="event__error">
                    <span onClick={this.props.clearAllErrors}>
                        <span className="visually-hidden">
                            Remove the error message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    {errorOneMsg}
                    {errorTwoMsg}
                </div>
            );
        }

        let hasDelete = false;
        if (this.props.status === 'Incomplete') {
            if (this.props.userIsCreator) {
                hasDelete = true;
            }
        }

        let hasDownload = false;
        if (this.props.eventId) {
            hasDownload = true;
        }

        return activeIndex === -1 ? (
            <Route component={ErrorPage} />
        ) : (
            <div>
                {this.props.getEventLoading ? (
                    <Loading />
                ) : (
                    <div>
                        {eventRejection}
                        {afterActionRequest}
                        {successMessage}
                        {errorMessage}
                        {errorTabsMessage}
                        <SubNav
                            eventId={this.props.eventId}
                            contract={this.props.contract}
                            startDate={this.props.startDate}
                            prAccessible={this.props.prAccessible}
                            status={this.props.status}
                        />
                        <Prompt
                            when={this.props.location.pathname.startsWith(
                                '/event/event-details'
                            )}
                            message={location => {
                                return !location.pathname.startsWith(
                                    '/event/event-details'
                                )
                                    ? 'Do you wish to leave the page? Any unsaved changes will be lost.'
                                    : true;
                            }}
                        />

                        <div className="event__content">
                            <div className="event__header">
                                <div className="event__event-name">
                                    {this.props.eventName}

                                    {this.props.groupStatus &&
                                        this.props.groupSubStatus && (
                                            <div className="groupStatus">
                                                <div className="groupStatus__wrapper">
                                                    <span className="groupStatus__title">
                                                        Status:
                                                    </span>
                                                    <span className="groupStatus__value">
                                                        {this.props.groupStatus}
                                                    </span>
                                                </div>
                                                <div className="groupStatus__wrapper">
                                                    <span className="groupStatus__title">
                                                        Sub Status:
                                                    </span>
                                                    <span className="groupStatus__value">
                                                        {
                                                            this.props
                                                                .groupSubStatus
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    {/* This is for HHEAC and if the event has a handheld enabled */}
                                    {this.props.eacCode &&
                                        this.props.handheld === '1' &&
                                        this.props.status !== 'Rejected' &&
                                        this.props.status !== 'Incomplete' && (
                                            <div>
                                                <div className="eacEventCode">
                                                    EAC EVENT CODE:{' '}
                                                    {this.props.eacCode}{' '}
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href="https://www.marines.com/events"
                                                        className="eacEventUrl"
                                                    >
                                                        https://www.marines.com/events
                                                    </a>
                                                </div>
                                                <Modal
                                                    title="Real-time Forms Submitted"
                                                    classes="btn btn--secondary"
                                                    modalClassName="modal-lead-count"
                                                    toggleAction={
                                                        this.props
                                                            .modalLeadCount
                                                    }
                                                    toggleModal={
                                                        this.props
                                                            .getLeadCountThunk
                                                    }
                                                >
                                                    <div>
                                                        <Headline
                                                            tagValue={3}
                                                            title="Real-time Forms Submitted : "
                                                        />

                                                        <p className="leadTotal">
                                                            {this.props
                                                                .leadCount
                                                                ? this.props
                                                                      .leadCount
                                                                : 0}
                                                        </p>
                                                    </div>
                                                </Modal>
                                            </div>
                                        )}
                                </div>

                                {hasDelete || hasDownload ? (
                                    <Utilities
                                        download
                                        delete={hasDelete}
                                        deleteEvent={this.props.deleteEvent}
                                        fetchEventPDF={this.props.fetchEventPDF}
                                        eventId={this.props.eventId}
                                        jwtToken={this.props.jwtToken}
                                    />
                                ) : null}
                            </div>

                            <TabStructure
                                items={this.formContent}
                                tab={this.props.match.params.tab}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default EventDetails;



// WEBPACK FOOTER //
// ./src/components/event/event-details/index.js